<template>
  <v-app-bar app color="red darken-4" dark>
    <div class="d-flex align-center">
      <router-link to="/">
        <v-img
          class="shrink mr-2"
          contain
          src="../assets/logo.png"
          transition="scale-transition"
          width="160"
        />
      </router-link>
      <v-spacer></v-spacer>
    </div>
    <v-spacer></v-spacer>
    <v-btn @click="GoToOrders" rounded class="mr-5">الطلبات السابقة</v-btn>
    <v-dialog v-model="dialog" persistent width="90vh">
      <template v-slot:activator="{ props, on }">
        <v-btn v-bind="props" v-on="on" rounded class="mr-5">
          تغيير كلمة المرور
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-h5"> تغيير كلمة المرور </v-card-title>
        <v-container fluid>
          <v-row>
            <v-col offset="2" cols="8">
              <v-text-field
                type="password"
                v-model="oldPassword"
                label="كلمة المرور الحالية"
                :rules="pwdRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="8">
              <v-text-field
                type="password"
                v-model="password"
                label="كلمة المرور الجديدة"
                :rules="pwdRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="8">
              <v-text-field
                type="password"
                v-model="passwordConfirm"
                label="تأكيد كلمة المرور"
                :rules="pwdRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="8">
              <b v-if="NotMatch" style="color: red">كلمة المرور لا تتطابق</b>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="LockChange"
            rounded
            variant="text"
            @click="ChnagePassword"
          >
            تغيير كلمة المرور
          </v-btn>
          <v-btn color="error" rounded variant="text" @click="dialog = false">
            اغلاق
          </v-btn>
        </v-card-actions>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar1"
          :timeout="timeout"
          color="error"
        >
          حدث خطأ ما اثناء عملية تغيير كلمة المرور
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar2"
          :timeout="timeout"
          color="success"
        >
          العملية تمت بنجاح
        </v-snackbar>
      </v-card>
    </v-dialog>
    <v-btn @click="GoTocheck" rounded class="mr-5"
      ><v-icon>mdi-cart</v-icon>تأكيد الطلب</v-btn
    >
    <v-btn rounded @click="GoToAdmin" class="mr-5" v-if="IsAdmin"
      >صفحة الاعدادات</v-btn
    >
    <v-btn rounded @click="Logout"><v-icon>mdi-logout</v-icon>تسجيل الخروج</v-btn>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar"
      :timeout="timeout"
      color="error"
    >
      لا يمكنك الاستمرار بسلة فارغة
    </v-snackbar>
  </v-app-bar>
</template>

<script>
import router from "@/router";
export default {
  name: "NavBar",
  data() {
    return {
      IsAdmin: false,
      timeout: 2500,
      snackbar: false,
      dialog: false,
      snackbar1: false,
      snackbar2: false,
      oldPassword: "",
      password: "",
      passwordConfirm: "",
      pwdRules: [
        (v) => !!v || "كلمة المرور مطلوبة",
        (v) => (v && v.length >= 6) || "ادنى حد لكلمة المرور هو 6",
      ],
    };
  },
  created() {
    const baseURI = "https://erp.matein3.com/api/Customer/policy";
    this.$axios.get(baseURI).then((result) => {
      this.IsAdmin = result.data.data;
    });
  },
  methods: {
    ChnagePassword() {
      this.$axios
        .post("Customer/change-password", {
          oldPassword: this.oldPassword,
          newPassword: this.password,
        })
        .then(({ data }) => {
          if (data.is_success) {
            this.snackbar2 = true;
            this.dialog = false;
          } else {
            this.snackbar1 = true;
          }
        })
        .catch(({ message }) => (this.snackbar1 = true));
    },
    GoTocheck() {
      if (this.$store.getters.CurrentCart.length === 0) this.snackbar = true;
      else this.$router.push({ name: "Checkout" });
    },
    Logout() {
      this.$store.dispatch("Logout");
      this.$router.push({ name: "login" });
    },
    GoToAdmin() {
      this.$router.push({ name: "Admin" });
    },
    GoToOrders() {
      this.$router.push({ name: "Orders" });
    },
  },
  computed: {
    LockChange() {
      return this.oldPassword !== "" &&
        this.password !== "" &&
        this.password.length > 5 &&
        this.oldPassword.length > 5 &&
        this.password === this.passwordConfirm
        ? false
        : true;
    },
    NotMatch() {
      return this.password !== this.passwordConfirm && this.password !== ""
        ? true
        : false;
    },
  },
};
</script>
